import { SITE } from "../config";

const STATS = [
  { value: `$${SITE.price}`, label: "One-time" },
  { value: "72h", label: "To go live" },
  { value: "1 Year", label: "Free hosting" },
];

export const OfferBar = ({ className = "" }) => (
  <div
    data-testid="offer-bar"
    className={`relative overflow-hidden rounded-2xl border border-volt/30 bg-volt/[0.07] ${className}`}
  >
    <div className="grid grid-cols-3 divide-x divide-volt/15">
      {STATS.map((s) => (
        <div key={s.value} className="px-3 py-4 text-center sm:px-5 sm:py-5">
          <div className="font-display text-2xl font-extrabold leading-none tracking-tight text-volt glow-text sm:text-4xl">
            {s.value}
          </div>
          <div className="mt-1.5 font-mono text-[9px] uppercase leading-tight tracking-[0.14em] text-mist sm:text-[11px]">
            {s.label}
          </div>
        </div>
      ))}
    </div>
  </div>
);
